import { ref, onMounted, onUnmounted } from "vue";
import type { Ref } from "vue";
import type { SureRef } from "@toolsie/composables";
/**
 * @function useBreakpoint - composable to determine if the screen is smaller a threshold
 * @param {SureRef<number>} breakpointValue - the threshold in pixels
 * @returns  flags for threshold equal, smaller or equal and greater
 */
export default function useBreakpoint(breakpointValue: SureRef<number>): {
  smaller: Ref<boolean>;
  greater: Ref<boolean>;
  equal: Ref<boolean>;
} {
  /** @const {Ref<boolean>} smaller - the screen is size is smaller or equal than the breakpoint */
  const smaller = ref(false);
  /** @const {Ref<boolean>} greater - the screen is greater the breakpoint */
  const greater = ref(false);
  /** @const {Ref<boolean>} equal - the screen has the size of the breakpoint */
  const equal = ref(false);

  const breakpoint = ref(breakpointValue);

  function checkBreakpoint() {
    if (window.innerWidth == breakpoint.value) {
      equal.value = true;
      smaller.value = true;
      greater.value = false;
    } else {
      equal.value = false;
      if (window.innerWidth < breakpoint.value) {
        smaller.value = true;
        greater.value = false;
      } else {
        smaller.value = false;
        greater.value = true;
      }
    }
  }

  //attach isMobileSize to lifecycle hook
  onMounted(() => {
    window.addEventListener("load", checkBreakpoint);
    window.addEventListener("resize", checkBreakpoint);
  });
  //attach isMobileSize to lifecycle hook
  onUnmounted(() => {
    window.removeEventListener("load", checkBreakpoint);
    window.removeEventListener("resize", checkBreakpoint);
  });

  return { greater, smaller, equal };
}
